module.exports = __webpack_public_path__ + "img/1-10.ef4f79af.png";